import { render, staticRenderFns } from "./TodoReturn.vue?vue&type=template&id=771300a8&scoped=true&"
import script from "./TodoReturn.vue?vue&type=script&lang=js&"
export * from "./TodoReturn.vue?vue&type=script&lang=js&"
import style0 from "./TodoReturn.vue?vue&type=style&index=0&id=771300a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771300a8",
  null
  
)

export default component.exports